module.exports = __webpack_public_path__ + "_/ifx-react-core/src/assets/styles/framework/components/react-widgets/img//loading.gif";